import { store } from '../../store/store'
import { useCallback, useSyncExternalStore } from 'react'
import { setCommonState } from '../../store/slices/commonStateSlice'
import { CommonStates } from '../types/enums'

export const useCommonLoading = () => {
  const commonLoading = useSyncExternalStore(
    store.subscribe,
    () => store.getState().commonState.data[CommonStates.LOADING],
  )

  const setCommonLoading = useCallback((value: boolean) => {
    store.dispatch(
      setCommonState({
        stateName: CommonStates.LOADING,
        state: value,
      }),
    )
  }, [])

  return { commonLoading, setCommonLoading }
}
